<ng-container *ngIf="!loadingRow">
  <td class="no-padding" (click)="openInspection()" [@fadeIn]>
    <span class="eval eval--{{inspection.Evaluation | lowercase}}">{{inspection.Evaluation}}</span>
  </td>
  <td (click)="openInspection()" [@fadeIn]>{{inspection.InspectionDate | date:'dd/MMM/yyyy'}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Examiner">{{inspection.Examiner | truncate:[18]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.SerialNumber">{{inspection.SerialNumber | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.UnitNumber">{{inspection.UnitNumber | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.AddiUnitNumber">{{inspection.AddiUnitNumber | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.CustomerName">{{inspection.CustomerName | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.JobsiteName">{{inspection.JobsiteName | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Make">{{inspection.Make | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Model">{{inspection.Model | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn] [attr.title]="inspection.Family">{{inspection.Family | truncate:[13]}}</td>
  <td (click)="openInspection()" [@fadeIn]>
    <span class="status status--{{inspection.Status | lowercase}}">
      {{inspection.Status | translate | async}}
    </span>
  </td>
  <td> 
    <!-- <i *ngIf="inspection.IsFlagged==false" class="material-icons" style="font:rgb(163, 154, 154)" >flag</i> -->
    <i *ngIf="inspection.IsFlagged==true" class="material-icons" style="color: red;" >flag</i>

  </td>
</ng-container>
<ng-container *ngIf="loadingRow">
  <td colspan="10">
    <div class="ph-item" style="height: 33px;">
      <div class="ph-row">
        <div class="ph-col-12"></div>
      </div>
    </div>
  </td>
</ng-container>
